export default __webpack_public_path__ + "static/media/nitzan2.51eb3567.jpg";